import React from 'react';
import Navigation from '../components/Navigation';
import Collect from '../components/Collect';
import Footer from '../components/Footer';
import { contact } from '../mock';

const CollectPage = () => {
  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content with top padding */}
      <div className="pt-20 sm:pt-24">
        <Collect contact={contact} />
      </div>
      <Footer />
    </div>
  );
};

export default CollectPage;
